'use es6';

import { getTimestamp } from '../../common-message-format/operators/commonMessageFormatGetters';
import { areDifferentDays } from './areDifferentDays';
export const shouldRenderDate = (message, previousMessage, displayInitialMessageDate) => {
  if (!previousMessage && !displayInitialMessageDate) {
    return false;
  }
  return Boolean(getTimestamp(message) && (!previousMessage || areDifferentDays(previousMessage, message)));
};